export interface PwaPlatformState {
  iosLike: boolean;
  installed: boolean;
}

export function isIosLikePlatform(
  userAgent: string,
  platform: string,
  maxTouchPoints: number,
): boolean {
  return /iPad|iPhone|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
}

export function isStandaloneDisplay(
  displayModeStandalone: boolean,
  navigatorStandalone: boolean | undefined,
): boolean {
  return displayModeStandalone || navigatorStandalone === true;
}

export function readPwaPlatformState(): PwaPlatformState {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return { iosLike: false, installed: false };
  }

  const standaloneNavigator = navigator as Navigator & { standalone?: boolean };
  return {
    iosLike: isIosLikePlatform(navigator.userAgent, navigator.platform, navigator.maxTouchPoints),
    installed: isStandaloneDisplay(
      window.matchMedia('(display-mode: standalone)').matches,
      standaloneNavigator.standalone,
    ),
  };
}
